import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import {messages} from './languages'

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false
  }
}

i18n.use(LanguageDetector).init({
  debug: false, // ← Desligando debug
  defaultNS: ['translations'],
  fallbackLng: 'pt',
  ns: ['translations'],
  resources: messages,
  returnNull: false,
  detection: {
    // Configure o detector para usar apenas localStorage e não detectar automaticamente
    order: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'], // language to not persist (localStorage)
  },
})

export {i18n}
